export const SESSION_RECEIVED = 'SESSION_RECEIVED';
